import _objectSpread from'@babel/runtime/helpers/objectSpread2';import {useIntl}from'react-intl';import useRichTextValues from'./useRichTextValues.js';function useRichIntl() {
  var intl = useIntl();
  var richTextValues = useRichTextValues();
  return _objectSpread(_objectSpread({}, intl), {}, {
    formatMessage: function formatMessage(options, values, errorValues) {
      return intl.formatMessage(options, _objectSpread(_objectSpread(_objectSpread({}, richTextValues), values), errorValues));
    }
  });
}export{useRichIntl as default};